/* global _, angular */

(function () {
  var module = angular.module('ace.generalFilters', []);

  module.filter('reverse', function () {
    return function (input, uppercase) {
      var out = '';
      for (var i = 0; i < input.length; i++) {
        out = input.charAt(i) + out;
      }
      // conditional based on optional argument
      if (uppercase) {
        out = out.toUpperCase();
      }
      return out;
    };
  });

  module.filter('range', function () {
    return function (input, currentIndex) {
      var output = [];
      for (var i in input) {
        if (i > currentIndex - 8 && i < currentIndex + 6) {
          output.push(input[i]);
        }
      }
      return output;
    };
  });

  module.filter('encodeURI', function () {
    return function (input) {
      return window.encodeURI(input);
    };
  });

  module.filter('encodeURIComponent', function () {
    return function (input) {
      return window.encodeURIComponent(input);
    };
  });

  module.filter('pad', function () {
    return function (num, len, char) {
      char = char || '0';
      len = len || 2;
      num += '';
      return num.length >= len
        ? num
        : new Array(len - num.length + 1).join(char) + num;
    };
  });

  module.filter('if', function () {
    return function (input, trueValue, falseValue) {
      return input ? trueValue : falseValue;
    };
  });

  module.filter('deZero', function () {
    return function (input) {
      return input + 1;
    };
  });

  module.filter('floor', function () {
    return function (input) {
      return Math.floor(input);
    };
  });

  module.filter('stripTags', function () {
    return function stripTags(input, allowed) {
      allowed = (
        ((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []
      ).join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
      var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
      var commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
      return input
        .replace(commentsAndPhpTags, '')
        .replace(tags, function ($0, $1) {
          return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
        });
    };
  });

  module.filter('truncateWords', function () {
    return function (input, wordCount, chars) {
      chars = chars || '…';

      var words = input.split(' ');

      if (words.length <= wordCount) {
        return input;
      } else {
        return words.slice(0, wordCount).join(' ') + chars;
      }
    };
  });

  module.filter('scotify', function () {
    return function (input) {
      var name = String(input);

      if (/^mc(.*)$/i.test(name)) {
        name =
          name.substr(0, 1) +
          '<span class="lowercase">' +
          name.substr(1, 1) +
          '</span>' +
          name.substr(2);
      }

      return name;
    };
  });

  module.filter('spanDescendersInLinks', [
    '$sce',
    function ($sce) {
      return function (input) {
        var links = input.match(/(?=<a)[^]+?>(.+?)<\/a>/g);

        angular.forEach(links, function (link) {
          var originalText = link.match(/>(.+)</)[1];
          var newText = originalText.replace(
            /(g|j|p|q|y)/g,
            '<span data-content="$1">$1</span>'
          );

          input = input.replace(originalText, newText);
        });

        return $sce.trustAsHtml(input);
      };
    },
  ]);

  module.filter('pluralize', function () {
    return function (input) {
      var plural = input;
      if (input.substr(input.length - 2) === 'us') {
        plural = plural.substr(0, plural.length - 2) + 'i';
      } else if (
        input.substr(input.length - 2) === 'ch' ||
        input.charAt(input.length - 1) === 'x' ||
        input.charAt(input.length - 1) === 's'
      ) {
        plural += 'es';
      } else if (
        input.charAt(input.length - 1) === 'y' &&
        ['a', 'e', 'i', 'o', 'u'].indexOf(input.charAt(input.length - 2)) === -1
      ) {
        plural = plural.substr(0, plural.length - 1) + 'ies';
      } else if (input.substr(input.length - 2) === 'is') {
        plural = plural.substr(0, plural.length - 2) + 'es';
      } else {
        plural += 's';
      }
      return plural;
    };
  });

  module.filter('camelCase', function () {
    return function (input) {
      return input.replace(/-\w/g, function (match) {
        return match[1].toUpperCase();
      });
    };
  });

  module.filter('propInArray', function () {
    return function (input, prop, arr) {
      return input.filter(function (obj) {
        return arr.indexOf(obj[prop]) !== -1;
      });
    };
  });

  module.filter('plainText', function () {
    return function (input) {
      if (!input) {
        return '';
      }
      input = input.replace(/<br(\/?)>|<\/p>/gi, ' ').replace(/\s{2,}/g, ' ');
      var text = angular.element('<span>' + input + '</span>').text();
      return text.trim();
    };
  });

  module.filter('deWidow', function () {
    return function (input, minWords, tags) {
      if (!input) {
        return '';
      }

      minWords = minWords || 2;
      tags = tags || ['p'];

      var isHtml = /^<(.*)>$/.test(input);

      if (isHtml) {
        var tempWrapperEl = angular.element('<span>' + input + '</span>');

        tags.forEach(function (tag) {
          angular.forEach(tempWrapperEl.find(tag), function (el) {
            var $el = angular.element(el);
            $el.html($el.html().replace(/ ([^ ]*)$/, '&nbsp;$1'));
          });
        });

        return tempWrapperEl.html();
      }

      var words = input.split(/\s/);

      if (words.length < minWords) {
        return input;
      }

      var lastWord = words.slice(-1)[0];
      var rejoinedWords = words.slice(0, -1).join(' ');

      return [rejoinedWords, lastWord].join(
        /\w/.test(lastWord) ? '&nbsp;' : ''
      );
    };
  });

  module.filter('toTitleCase', function () {
    return function (input) {
      if (!input) {
        return input;
      }

      return input.replace(/\w\S*/g, function (str) {
        if (/^(and|of)$/i.test(str)) {
          return str.toLowerCase();
        }
        return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
      });
    };
  });

  module.filter('toFixed', function () {
    return function (input, len) {
      len = len !== undefined ? len : 2;

      if (input === undefined) {
        return input;
      }

      if (typeof input !== 'number') {
        input = Number(input);
      }

      return input.toFixed(len);
    };
  });

  module.filter('trustAsHtml', [
    '$sce',
    function ($sce) {
      return function (input) {
        return $sce.trustAsHtml(input);
      };
    },
  ]);

  module.filter('group', [
    'HelperService',
    function (HelperService) {
      return _.memoize(function (entities, groupSize) {
        return HelperService.group(entities, groupSize);
      });
    },
  ]);

  module.filter('relativeUrls', function () {
    return function (input, url) {
      if (!input) {
        return input;
      }

      url = url || window.location.hostname.replace('www.', '');

      var urlPattern = new RegExp(
        'https?://(www.)?' + url.replace(/\./g, '\\.') + '/(.*)',
        'gim'
      );

      input = input.replace(urlPattern, '/$2');

      var wrapperEl = angular.element('<span>' + input + '</span>');

      angular.forEach(wrapperEl.find('a'), function (link) {
        if (link.hostname === window.location.hostname) {
          link.removeAttribute('target');
        } else {
          link.setAttribute('target', '_blank');
        }
      });

      return wrapperEl[0].innerHTML;
    };
  });
})();
